module.exports = __webpack_public_path__ + "50cdf89e99459415d78689775b8ed0ff.png";